<template>
  <div class="base-table">
    <v-data-table
      v-model="itemsSelected"
      :height="scrollableHeight"
      :headers="headers"
      :items="items"
      :items-per-page.sync="pagination.perPage"
      :server-items-length="pagination.total"
      :page.sync="pagination.currentPage"
      :loading="fetching"
      :hide-default-footer="hideDefaultFooter"
      :footer-props="{ 'itemsPerPageOptions': itemsPerPageOptions  }"
      @click:row="(any, value) => selectItem(value.item)"
      @update:page="fetchItems"
      @update:items-per-page="fetchItems"
      v-bind="props_"
    >
      <!-- <template #header.data-table-select="{ props, on }">
        <slot name="header.data-table-select" :props="props" :on="on">
          <v-simple-checkbox
            :value="props.value"
            :indeterminate="props.indeterminate"
            @input="on.input"
          />
        </slot>
      </template> -->
      <template #item.data-table-select="{ isSelected, select }">
        <slot
          name="item.data-table-select"
          :is-selected="isSelected"
          :select="select"
        >
          <v-simple-checkbox :value="isSelected" @input="select" />
        </slot>
      </template>
      <template
        v-for="header_ in headers"
        v-slot:[`header.${header_.value}`]="{ header }"
      >
        <slot :name="`header.${header_.value}`" :header="header">
          {{ header.text }}
        </slot>
      </template>
      <template
        v-for="header in headers"
        v-slot:[`item.${header.value}`]="{ item }"
      >
        <slot :name="`item.${header.value}`" :item="item">
          {{ getRowData(item, header.value) }}
        </slot>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { denormalize } from "@/helpers/JsonApiDenormalizer";

export default {
  props: {
    limit: {
      type: Number,
      default: 200,
    },
    fetchService: {
      type: Function,
    },
    fetchFunc: {
      type: String,
    },
    fetchOnInit: {
      type: Boolean,
      default: true,
    },
    fetchParams: {
      type: Object,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 300,
    },
    selected: {
      type: [Array, Object],
      default: () => [],
    },
    selectOnFetch: {
      type: Boolean,
      default: false,
    },
    props: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    scrollableHeight: 300,
    items: [],
    itemsSelected: [],
    pagination: {
      total: 0,
      perPage: 1000,
      currentPage: 1,
    },
    props_: {
      "fixed-header": true,
      "disable-sort": true,
    },
    fetching: false,
  }),
  created() {
    this.props_ = {
      ...this.props_,
      ...this.props,
    };
    this.setPaginationLimit(this.limit);
  },
  computed: {
    hideDefaultFooter() {
      return this.pagination.total < this.pagination.perPage;
    },
    itemsPerPageOptions() {
      let options = [10, 20, 50, 100, 200, 1000, -1];
      if (this.limit) {
        options = options.filter(num => {
          return (num > 0 && num <= this.limit);
        });
      }
      return options;
    }
  },
  mounted() {
    this.setScrollableHeight();

    if (this.fetchService && this.fetchFunc && this.fetchOnInit) {
      this.fetchItems();
    }
  },
  watch: {
    limit(num) {
      this.setPaginationLimit(num);
    },
    height(height) {
      this.setScrollableHeight();
    },
    itemsSelected(value) {
      let selected = value;

      if (this.props_["single-select"]) {
        selected = value && value.length ? value[0] : null;
      }

      this.$emit("update:selected", selected);
    },
    selected(value) {
      let selected = value;

      if (this.props_["single-select"]) {
        selected = value ? [value] : [];
      }

      this.itemsSelected = selected;
    },
  },
  methods: {
    setScrollableHeight() {
      this.scrollableHeight = this.height;

      if (!this.hideDefaultFooter) {
        this.scrollableHeight -= 59; // Footer height
      }
    },
    getRowData(row, path) {
      return path.split(".").reduce((acc, val) => {
        acc = acc[val] || "";
        return acc;
      }, row);
    },
    async fetchItems() {
      this.fetching = true;

      try {
        const data = await this.fetchService[this.fetchFunc]({
          ...this.fetchParams,
          limit: this.pagination.perPage,
          page: this.pagination.currentPage,
        }).then((response) => response.data);

        this.items = denormalize(data);

        this.pagination.total = data.meta.pagination.total;
        this.pagination.perPage = data.meta.pagination.per_page;
        this.pagination.currentPage = data.meta.pagination.current_page;
        this.$emit("update:pagination", this.pagination);

        this.setScrollableHeight();

        this.$emit("fetch", this.items);

        if (this.selectOnFetch && this.items.length) {
          this.selectItem(this.items[0]);
        }
      } catch (err) {}

      this.fetching = false;
    },
    selectItem(mixed) {
      if (this.$store.getters["Busy/ajaxIsLoading"]) {
        window.console && console.log('Click ignored. Ajax request(s) still in progress.');
        return;
      }
      const itemId = ["string", "number"].includes(typeof mixed)
        ? mixed
        : mixed.id;
      const itemSelectedIndex = this.itemsSelected.findIndex(
        (itemSelected) => itemSelected.id === itemId
      );

      // Deselect
      if (itemSelectedIndex > -1) {
        this.itemsSelected.splice(itemSelectedIndex, 1);
      } else {
        if (this.props_["single-select"]) {
          this.itemsSelected = [];
        }
        const item = this.items.find(item => item.id == itemId);
        if (item) {
          this.itemsSelected.push(item);
        }
      }
    },
    setPaginationLimit(limit) {
      const nextLimit = (typeof limit !== 'number' || ! limit)
        ? this.$data.pagination.perPage
        : limit;
      this.$set(this.$data.pagination, 'perPage', nextLimit);
    }
  },
};
</script>

<style lang="scss">
.base-table {
  .v-data-table th {
    white-space: nowrap;
  }
}
</style>
